<script>
	export default {
        props: {
		},
		data: function(){
            return {
				attached_images: [],
                attached_documents: [],
                image_data: [],
                document_data: [],
                full_image: {src: "", width: null, height: null},
                document_download: {data: null, name: null},
                image: {
                    naturalWidth: 0,
                    naturalHeight: 0,
                },
                api_load_prefix: "message", // can be formsubmission
            }
		},
        computed: {
            haveAttachments() {
                var count = 0;
                if(Array.isArray(this.attached_images)) {
                    count += this.attached_images.length;
                }
                if(Array.isArray(this.attached_documents)) {
                    count += this.attached_documents.length;
                }
                if(Array.isArray(this.image_data)) {
                    count += this.image_data.length;
                }
                if(Array.isArray(this.document_data)) {
                    count += this.document_data.length;
                }
				return count;
			},

        },
        mounted() {
        },
		methods: {
            /**
             * @todo This could do with a rethink now that we don't show the thumbnails, and that the AttachmentDisplay
             * component does all the image handling. We could possibly get rid of the loadThumbnails stuff from the 
             * MessageList, and then make this load the thumbnail and all the other data as required.
             * 
             * FOR NOW, don't forget that this function only works if the thumbnails are pre-loaded in to the 
             * image_data cache.
             * 
             * @see MessageListBase::loadThumbnails
             */
            loadImageData(id, archived = false) {
				var image = this.image_data.find((obj) => {return obj.id == id});
				if(image && image.data) {
					this.full_image = image;
				}
				else {
					axios.get(this.$root.apiBase + '/' + this.api_load_prefix + 'image/' + id + (archived ? "/1" : ""), { responseType: 'arraybuffer' }).then((res) => {

						let imageR = btoa(
							new Uint8Array(res.data)
								.reduce((data, byte) => data + String.fromCharCode(byte), '')
						);

						image.data = `data:${res.headers['content-type'].toLowerCase()};base64,${imageR}`;
						this.full_image = image;
					}).catch((error) => {
						console.log(error);
					});
				}
            },
            showDocumentDownloadDialog(document, archived) {
                if(document) {
                    this.document_download = {name: document.name, data: null}
                    this.loadDocumentData(document, archived);

                    this.$refs.documentDownloadDialog.show();
                }
			},
			loadDocumentData(document, archived) {
				var document_cache = this.document_data.find((obj) => {return obj.id == document.id});
				if(document_cache) {
					this.document_download.data = document_cache.data;
                }
                else {
                    axios.get(this.$root.apiBase + '/' + this.api_load_prefix + 'document/' + document.id + (archived ? "/1" : ""), { responseType: 'arraybuffer' }).then((res) => {
                        let documentRaw = btoa(
                            new Uint8Array(res.data)
                                .reduce((data, byte) => data + String.fromCharCode(byte), '')
                        );

                        var mimeType = this.getMimeType(res.headers['content-type'].toLowerCase());
                        this.document_download.data = `data:${mimeType};base64,${documentRaw}`;
                        this.document_data.push({id: document.id, data: this.document_download.data, name: document.name});
                    }).catch((error) => {
                        console.log(error);
                    });
                }
			},
            getMimeType(mimeType) {
                // iOS 14 stopped allowing pdf downloads on touch device throwing error 'Not allowed to navigate top frame to data URL' hacky solution here
                if(navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
                    return mimeType.replace("application/pdf", "application/x-pdf");
                } 
                else {
                    return mimeType;
                }
			},
			
			getImageSrc(id, thumb) {
				var image = this.image_data.find((obj) => {return obj.id == id});
				if(image) {
					return (thumb ? image.tn_data : image.data);
				}
				return "";
            },
            
            dataUrlToBlob(strUrl) {
                var myBlob = (window.Blob || window.MozBlob || window.WebKitBlob || toString);
                var parts= strUrl.split(/[:;,]/),
                type = parts[1],
                indexDecoder = strUrl.indexOf("charset")>0 ? 3: 2,
                decoder = parts[indexDecoder] == "base64" ? atob : decodeURIComponent,
                binData = decoder( parts.pop() ),
                mx = binData.length,
                i = 0,
                uiArr = new Uint8Array(mx);

                for(i;i<mx;++i) {
                    uiArr[i]= binData.charCodeAt(i);
                }

                return new myBlob([uiArr], {type: type});
            },
            initImageDownload(event, image, name) {
                if(navigator && navigator.msSaveBlob) {
                    navigator.msSaveBlob(this.dataUrlToBlob(image.data), name);
                    event.preventDefault();
                }
            },
            
            initDocumentDownload(event, document, name) {
                this.$refs.documentDownloadDialog.hide();
                if(navigator && navigator.msSaveBlob) {
                    navigator.msSaveBlob(this.dataUrlToBlob(document.data), name);
                    event.preventDefault();
                }
            },
            getShortImageDownloadName(owner, image_id) {
                return owner.id + "_" + image_id + ".png";
            },
            getImageDownloadName(owner, image_id) {
                return owner.user.surname.toUpperCase() + "_" + owner.user.forenames + "_" + (owner.user.dob ? this.moment(owner.user.dob).format("DD-MM-YYYY") : "dob-unknown") + "_" + owner.id + "_" + image_id + ".png";
            },
            convertURIToCanvas(URI) {
                return new Promise(function(resolve, reject) {
                    if (URI == null) return reject();
                    var canvas = document.createElement('canvas'),
                        context = canvas.getContext('2d'),
                        image = new Image();
                    image.addEventListener('load', function() {
                        canvas.width = image.width;
                        canvas.height = image.height;
                        context.drawImage(image, 0, 0, canvas.width, canvas.height);
                        resolve(canvas);
                    }, false);
                    image.src = URI;
                })
            },

            convertURIToImageData(URI) {
                return new Promise(function(resolve, reject) {
                    if (URI == null) return reject();
                    var canvas = document.createElement('canvas'),
                        context = canvas.getContext('2d'),
                        image = new Image();
                    image.addEventListener('load', function() {
                        canvas.width = image.width;
                        canvas.height = image.height;
                        context.drawImage(image, 0, 0, canvas.width, canvas.height);
                        resolve(context.getImageData(0, 0, canvas.width, canvas.height));
                    }, false);
                    image.src = URI;
                })
            },

            dataURItoBlob(dataURI) {
                // convert base64 to raw binary data held in a string
                // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
                var byteString = atob(dataURI.split(',')[1]);

                // separate out the mime component
                var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

                // write the bytes of the string to an ArrayBuffer
                var ab = new ArrayBuffer(byteString.length);

                // create a view into the buffer
                var ia = new Uint8Array(ab);

                // set the bytes of the buffer to the correct values
                for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }

                // write the ArrayBuffer to a blob, and you're done
                var blob = new Blob([ab], {type: mimeString});
                return blob;

            },
                
            blob2canvas(blob){
                var canvas = document.createElement("canvas");
                var ctx = canvas.getContext('2d');
                var img = new Image;
                img.onload = function () {
                    ctx.drawImage(img, 0, 0);
                }
                img.src = blob;
                return canvas;
            },
			resizeImage(image, max_width, max_height) {
				var canvas = document.createElement("canvas");
				var ctx = canvas.getContext("2d");

				var max_width = max_width;
				var max_height = max_height;
				var width = image.width;
				var height = image.height;

				if (width > height) {
					if (width > max_width) {
						height *= max_width / width;
						width = max_width;
					}
				}
				else {
					if (height > max_height) {
						width *= max_height / height;
						height = max_height;
					}
				}


				canvas.width = width;
				canvas.height = height;
				ctx.drawImage(image, 0, 0, width, height);

				return canvas;
			},
			getAttachment(e, question_name = null) {
                var promises = [];
				//console.log(e);
				// from an input element
				//console.log(e.target);
                var filesToUpload = e.target.files;
                //console.info(filesToUpload);
				if(!filesToUpload) {
					console.log("No files specified");
					return false;
				}
                Array.from(filesToUpload).forEach(file => {
                
                    e.target.value = "";

                    if(!file) {
                        // This crops up in bug reports now and then. Should never happen.
                        // Why the filesToUpload array would have an "undefined" element is unclear
                        //   "Cannot read property 'type' of undefined"
                        console.log("File is not defined.");
                    }
					// We sometimes get errors for file.type.match as "undefined is not an object"
					// No idea why or how this can happen as they should all be instances of File,
					// which is a subclass of Blob, and even an unknown Blob should have type set
					// as an empty string. So something is weird in SurveyJS sometimes (or in our)
					// code, but I've looked and can't see where we would be unsetting the type.
					// So we have to be super careful.
                    if (typeof file == "object" && typeof file.type == "string" && file.type.match(/image.*/)) {
                        promises.push(new Promise((resolve, reject) => {
                            var reader = new FileReader();
                            reader.onload = (readerEvent) => {
                                
                                console.log("Image read");
                                // console.log(JSON.stringify(readerEvent, null, 2));
                                var image = new Image();
                                image.onload = (imageEvent) => {
                                    var tn_canvas = this.resizeImage(image, 100, 100);
                                    var resize_canvas = this.resizeImage(image, 1000, 1000);
                                    console.log("Image loaded");
                                    var image_data = {
                                        tn_canvas: tn_canvas, 
                                        resize_canvas: resize_canvas, 
                                        file_name: file.name, 
                                        file_type: file.type, 
                                        tn_data_url: tn_canvas.toDataURL("image/png"), 
                                        data_url: resize_canvas.toDataURL("image/png"),
                                        question_name: question_name};
                                    this.attached_images.push(image_data);
                                    resolve(image_data);
                                }
                                image.src = readerEvent.target.result;
                            }
                            reader.onerror = reject;
                            reader.readAsDataURL(file);
                        }));
                    }
                    // This is really shit, but on some windows versions the file.type is not set for documents. So
                    // we have to use the extension instead. Not good, Microsoft. Not good at all.
                    else if (
                            file.type == "application/msword"
                            || file.type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            || file.type == "application/vnd.oasis.opendocument.text"
                            || file.type == "application/vnd.ms-excel"
                            || file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            || file.type == "application/vnd.oasis.opendocument.spreadsheet"
                            || file.type == "application/pdf"
                            || file.name.endsWith(".doc")
                            || file.name.endsWith(".docx")
                            || file.name.endsWith(".odt")
                            || file.name.endsWith(".xls")
                            || file.name.endsWith(".xlsx")
                            || file.name.endsWith(".ods")
                            || file.name.endsWith(".pdf")) {
                        promises.push(new Promise((resolve, reject) => {
                            var reader = new FileReader();
                            reader.onloadend = () => {
                                var document_data = {
                                    file_name: file.name, 
                                    file_type: file.type, 
                                    data_url: reader.result, 
                                    question_name: question_name}
                                this.attached_documents.push(document_data);
                                resolve(document_data);
                            };
                            reader.onerror = reject;
                            reader.readAsDataURL(file);
                        }));
                    }
                    else {
                        console.log("Not a supported upload format. Supported image formats are: png and jpeg (or images taken directly from your camera). Supported document formats are: doc, docx, odt, xls, xlsx, ods");
                        this.addNotification({type: "warning", content: 'Not a supported upload format. Supported image formats are: png and jpeg (or images taken directly from your camera). Supported document formats are: pdf, doc, docx, odt, xls, xlsx, ods'});

                        //return false;
                    };
                    // // from drag-and-drop
                    // function onDrop(e) {
                    // 	filesToUpload = e.dataTransfer.files;
                    // }
                });
                return Promise.all(promises);
            },
            
			showFullImageDialog(id, archived = false) {
				this.full_image = {src: "", width: null, height: null};
				this.loadImageData(id, archived);
                this.zoomScale = 1;
                this.rotateDeg = 0;
                this.marginTop = 0;
				this.$refs.fullImageDialog.show();
                
            },

            formToObject( elem ) {
                var current, entries, item, key, output, value;
                output = {};
                entries = elem.entries();
                // Iterate over values, and assign to item.
                while ( item = entries.next().value )
                {
                    // assign to variables to make the code more readable.
                    key = item[0];
                    value = item[1];
                    // Check if key already exist
                    if (Object.prototype.hasOwnProperty.call( output, key)) {
                        current = output[ key ];
                        if ( !Array.isArray( current ) ) {
                        // If it's not an array, convert it to an array.
                        current = output[ key ] = [ current ];
                        }
                        current.push( value ); // Add the new value to the array.
                    } else {
                        output[ key ] = value;
                    }
                }
                return output;
            },
            formToJSON( elem ) {
                return JSON.stringify( this.formToObject(elem) );
            },
            defang(name) {
                return name.replace(/[^a-z0-9_.-]/gi, '_');
            },
            objectToFlatForm(data, attachment_meta_key = null) {
                var form = new FormData();

                for(var key in data) {
                    switch(key) {
                        case "attached_images":
                            if(Array.isArray(data[key])) {
                                data[key].forEach((value, index) => {
                                    form.append("attached_images[]", this.dataURItoBlob(value.data_url), this.defang(value.file_name));
                                    if(attachment_meta_key) {
                                        form.append("attached_images_meta[]", value[attachment_meta_key]);
                                    }
                                });
                            }
                            break;
                        case "attached_documents":
                            if(Array.isArray(data[key])) {
                                data[key].forEach((value, index) => {
                                    form.append("attached_documents[]", this.dataURItoBlob(value.data_url), this.defang(value.file_name));
                                    if(attachment_meta_key) {
                                        form.append("attached_documents_meta[]", value[attachment_meta_key]);
                                    }
                                });
                            }
                            break;
                        default:
                            form.append(key, JSON.stringify(data[key]));
                    }
                }

                return form;
            },
            objectToForm(data, images) {
                var form = new FormData();

                var normal_data = {};

                for(var key in data) {
                    switch(key) {
                        case "attached_images":
                            if(Array.isArray(data[key])) {
                                data[key].forEach((value, index) => {
                                    form.append("attached_images[]", this.dataURItoBlob(value.data_url), this.defang(value.file_name));
                                });
                            }
                            break;
                        case "attached_documents":
                            if(Array.isArray(data[key])) {
                                data[key].forEach((value, index) => {
                                    form.append("attached_documents[]", this.dataURItoBlob(value.data_url), this.defang(value.file_name));
                                });
                            }
                            break;
                        default:
                            normal_data[key] = data[key];
                    }
                }

                form.append("data", JSON.stringify(normal_data));

                return form;
            },
            objectsToForm(data, images) {
                var form = new FormData();

                data.forEach((data_value, data_index) => {


                    var normal_data = {};

                    for(var key in data_value) {
                        switch(key) {
                            case "attached_images":
                                if(Array.isArray(data_value[key])) {
                                    data_value[key].forEach((value, index) => {
                                        form.append("attached_images[" + data_index + "][]", this.dataURItoBlob(value.data_url), this.defang(value.file_name));
                                    });
                                }
                                break;
                            case "attached_documents":
                                if(Array.isArray(data_value[key])) {
                                    data_value[key].forEach((value, index) => {
                                        form.append("attached_documents[" + data_index + "][]", this.dataURItoBlob(value.data_url), this.defang(value.file_name));
                                    });
                                }
                                break;
                            case "user":
                                // The user data is causing the POST data to be bloated
                                // so we filter this out.
                                break;
                            default:
                                normal_data[key] = data_value[key];
                        }
                    }

                    form.append("data[" + data_index + "]", JSON.stringify(normal_data));
                });

                return form;
            },
        }   
    }
</script>
